import { type Ripple } from "@dashboard/ripples/types";

export const rippleProductTypeInHeader: Ripple = {
  type: "improvement",
  ID: "product-type-in-header",
  TTL_seconds: 60 * 60 * 24 * 7,
  content: {
    oneLiner: "Product type in header",
    contextual:
      "제품 유형이 제품 이름 옆에 표시됩니다. 클릭하여 해당 유형의 모든 제품을 볼 수 있습니다. 또는 더 많은 작업에서 유형 설정을 사용할 수 있습니다.",
    global:
      "제품 상세 페이지에서 제품 유형이 제품 이름 옆에 표시됩니다. 주문 채널과 유사하게 클릭하여 해당 유형의 제품 목록으로 이동할 수 있습니다. 속성, 변형 또는 다른 유형 옵션을 변경하려면 페이지 상단의 더 많은 작업 메뉴에서 제품 유형 설정을 선택하세요.",
  },
  dateAdded: new Date(2026, 4, 30),
};
